import { defineMessages } from 'react-intl';

export default defineMessages({
  DESCRIPTION: {
    defaultMessage: '<b>Description : </b> {description}',
  },

  LESSON_TITLE: {
    defaultMessage: '<b>Cours : </b> {title}',
  },
} as const);
